/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Dialog, Grid, IconButton, Typography} from "@mui/material";
import {AddReaction, Close, Delete} from "@mui/icons-material";
import {useEffect, useState} from "react";


const IngresoSelectMultipleIcono = ({
                                        props,
                                        dato,
                                        opciones = [],
                                        titulo='Relacionar'
                                    }) => {
    const {register, errors, control, setValue, watch, getValues} = props
    const [open, setOpen] = useState(false)
    const [seleccionadas, setSeleccionadas] = useState([])


    const seleccionar = (e) => {
        setOpen(false)
        setValue(dato + '.' + seleccionadas.length, e)
    }

    const borrar = (e) => {

        let index = seleccionadas.findIndex((ir) => ir === e)
        let arr = seleccionadas
        delete arr[index]
        setValue(dato, arr)
    }

    useEffect(() => {

        let ic = getValues(dato)
        if (ic) {
            setSeleccionadas(ic)
        }


    }, [watch(dato)]);
    return (


        <>
            {seleccionadas.length > 0 ?
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    {seleccionadas.map((it, index) => {
                        return (

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 4}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}
                                      sx={{mb: -4}}>
                                    <IconButton
                                        onClick={() => borrar(it)}
                                    ><Delete/></IconButton>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <img
                                        onClick={() => setOpen(true)}
                                        src={it} width={'100%'} height={'auto'}
                                        style={{cursor: 'pointer'}}

                                    />
                                </Grid>


                            </Grid>


                        )
                    })}

                    <Grid container size={{xs: 12, sm: 12, md: 4}}
                          sx={{justifyContent: 'center', alignItems: 'center', minHeight: 20}}>
                        <IconButton
                            onClick={() => setOpen(true)}
                            sx={{backgroundColor: '#EBEBEB', p: 1.5, boxShadow: 2}}

                        >

                            <AddReaction

                                color={'primary'} sx={{width: 20, height: 20}}/>

                        </IconButton>
                    </Grid>

                </Grid>

                :
                <IconButton
                    onClick={() => setOpen(true)}
                    sx={{backgroundColor: '#EBEBEB', p: 1.5, boxShadow: 2}}

                >

                    <AddReaction

                        color={'primary'} sx={{width: 20, height: 20}}/>

                </IconButton>

            }


            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth={'xs'}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{p: 4}}

                >

                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{mt: 1}}>
                        <Typography>{titulo}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 6}}
                          sx={{justifyContent: 'flex-end', mr: -3, ml: 3, mt: -3}}>
                        <IconButton
                            onClick={() => setOpen(false)}
                        >
                            <Close/>
                        </IconButton>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={4}
                        >

                            {opciones.map((item, index) => {
                                return (
                                    <Grid
                                        onClick={() => seleccionar(item)}
                                        container size={{xs: 12, sm: 12, md: 3}}
                                        sx={{
                                            transition: "all .2s ease-in-out",
                                            justifyContent: 'center',
                                            p: 1,
                                            border: 1,
                                            borderColor: '#00000000',
                                            borderRadius: 2,
                                            boxShadow: 4,
                                            cursor: 'pointer',
                                            "&:hover": {
                                                borderColor: '#00000050',
                                            }
                                        }}
                                    >

                                        <img src={item} width={'90%'}/>


                                    </Grid>
                                )
                            })}


                        </Grid>
                    </Grid>


                </Grid>

            </Dialog>
        </>
    )

}
export default IngresoSelectMultipleIcono
